__turbopack_context__.v({
  "show": "AcfStats-module-scss-module__prp7dq__show",
  "stat": "AcfStats-module-scss-module__prp7dq__stat",
  "stat_desc": "AcfStats-module-scss-module__prp7dq__stat_desc",
  "stat_num": "AcfStats-module-scss-module__prp7dq__stat_num",
});
